<template>
  <div>
    <section class="middle-content" style="padding-top: 40px">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <object
              width="1060"
              height="1200"
              type="application/pdf"
              :data="
                cdn +
                '/docs/User Guide Trransfer-protected.pdf?#zoom=100&scrollbar=0&toolbar=0&navpanes=0'
              "
            >
              <p>File couldn't be loaded.</p>
            </object>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/guide/Guide.vue